import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_EMPLOYEETAX,
  DELETE_EMPLOYEETAX,
  UPDATE_EMPLOYEETAX,
  ADD_NEW_EMPLOYEETAX,
} from "./actionType";

import {
  getEmployeeTaxSuccess,
  getEmployeeTaxFail,
  deleteEmployeeTaxSuccess,
  deleteEmployeeTaxFail,
  updateEmployeeTaxSuccess,
  updateEmployeeTaxFail,
  addEmployeeTaxSuccess,
  addEmployeeTaxFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveEmployeeTaxApi,
  getEmployeeTaxApi,
  updateEmployeeTaxApi,
  deleteEmployeeTaxApi,
  addNewEmployeeTaxApi
} from "../../helpers/backend_helper";

function* getEmployeeTax({ payload: employeeTax }) {
  try {
    const response = yield call(getEmployeeTaxApi, employeeTax);
    yield put(getEmployeeTaxSuccess(GET_EMPLOYEETAX, response.data));
  } catch (error) {
    yield put(getEmployeeTaxFail(GET_EMPLOYEETAX, error));
  }
}

function* onUpdateEmployeeTax({ payload: employeeTax }) {
  try {
    if (employeeTax.setApprove) {
      const response = yield call(approveEmployeeTaxApi, employeeTax);
      yield put(updateEmployeeTaxSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateEmployeeTaxApi, employeeTax);
      yield put(updateEmployeeTaxSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateEmployeeTaxFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteEmployeeTax({ payload: employeeTax }) {
  try {
    const response = yield call(deleteEmployeeTaxApi, employeeTax);
    yield put(deleteEmployeeTaxSuccess({ employeeTax, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteEmployeeTaxFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewEmployeeTax({ payload: employeeTax }) {
  try {
    const response = yield call(addNewEmployeeTaxApi, employeeTax);
    yield put(addEmployeeTaxSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addEmployeeTaxFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetEmployeeTax() {
  yield takeEvery(GET_EMPLOYEETAX, getEmployeeTax);
}

export function* watchUpdateEmployeeTax() {
  yield takeEvery(UPDATE_EMPLOYEETAX, onUpdateEmployeeTax);
}

export function* watchDeleteEmployeeTax() {
  yield takeEvery(DELETE_EMPLOYEETAX, onDeleteEmployeeTax);
}

export function* watchAddNewEmployeeTax() {
  yield takeEvery(ADD_NEW_EMPLOYEETAX, onAddNewEmployeeTax);
}

function* employeeTaxSaga() {
  yield all([
    fork(watchGetEmployeeTax),
    fork(watchDeleteEmployeeTax),
    fork(watchUpdateEmployeeTax),
    fork(watchAddNewEmployeeTax)
  ]);
}

export default employeeTaxSaga;
